import { z } from 'zod';
import { bucketRequestSchema } from '../../bucket/api/bucket-types';
// category request
export const categoryRequestSchema = z.object({
    id: z.string().uuid(),
    budgetId: z.string().uuid(),
    name: z.string(),
    notes: z.string().optional(),
    position: z.number(),
    buckets: z.array(bucketRequestSchema).optional(),
});
// category request add
export const categorySchema = categoryRequestSchema.extend({});
// category sort
export const categoryRequestSortSchema = z.object({
    budgetId: z.string().uuid(),
    ids: z.array(z.string().uuid()),
});
// category sort all
export const categoryRequestSortCategorySchema = z.object({
    categoryId: z.string().uuid(),
    bucketIds: z.array(z.string().uuid()),
});
export const categoryRequestSortAllSchema = z.object({
    budgetId: z.string().uuid(),
    categories: categoryRequestSortCategorySchema.array(),
});
// category delete
export const categoryDeleteSchema = z.object({
    budgetId: z.string().uuid(),
    id: z.string().uuid(),
});
